import { render, staticRenderFns } from "./PdfCreate5.vue?vue&type=template&id=51957d05&scoped=true"
import script from "./PdfCreate5.vue?vue&type=script&lang=js"
export * from "./PdfCreate5.vue?vue&type=script&lang=js"
import style0 from "./PdfCreate5.vue?vue&type=style&index=0&id=51957d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51957d05",
  null
  
)

export default component.exports